import { useEffect, useRef } from 'react'
import { setBurstLive, setBurstNoData, setFluxLive, setFluxNoData } from './fluxLiveSlice'
import { useAppDispatch } from './hooks'
import { serverUrl } from '../utilites/config'
import { reconnectingSocket } from '../utilites/socket'

/**
 * Hook that maintains WebSocket connections to track live data status.
 * This runs at the MainView level so status persists across tab switches.
 */
export function useLiveStatusWebSocket() {
  const dispatch = useAppDispatch()
  const fluxConnectionRef = useRef<any>(null)
  const burstConnectionRef = useRef<any>(null)
  const locationRef = useRef(window.location.href)

  useEffect(() => {
    // Handler for FLUX live data
    const handleFluxData = (d: any) => {
      if (d.body !== 'NO_DATA') {
        dispatch(setFluxLive())
      } else {
        dispatch(setFluxNoData())
      }
    }

    // Handler for Burst/Spectrogram live data
    const handleBurstData = (d: any) => {
      if (d.body !== 'NO_DATA') {
        dispatch(setBurstLive())
      } else {
        dispatch(setBurstNoData())
      }
    }

    // Connect to FLUX WebSocket (F10.7 band - primary)
    fluxConnectionRef.current = reconnectingSocket(
      serverUrl + '/websocket',
      handleFluxData,
      '/topic/flux-live',
      locationRef.current
    )

    // Connect to Burst WebSocket (F10.7 band - primary)
    burstConnectionRef.current = reconnectingSocket(
      serverUrl + '/websocket',
      handleBurstData,
      '/topic/burst-live',
      locationRef.current
    )

    return () => {
      // Cleanup FLUX connection
      const fluxConn = fluxConnectionRef.current
      if (fluxConn) {
        fluxConn.disconnect?.()
      }

      // Cleanup Burst connection
      const burstConn = burstConnectionRef.current
      if (burstConn) {
        burstConn.disconnect?.()
      }

      fluxConnectionRef.current = null
      burstConnectionRef.current = null
    }
  }, [dispatch])
}
